import React from "react";
import { Flex } from "@jsq/ds/core";
import {
  FormTextInput,
  FormPercentInput,
  useFormContext,
  CancelButton,
  SubmitButton,
} from "@jsq/ds/forms";
import { Sizes } from "@jsq/ds/styles";
import { isIndividualAccountType } from "../../../utils/account_types";
import { declarationButtonWrapper } from "./styles_vanilla.css";
import { DeclarationFormValues } from "./types";

export const DeclarationFormContent = ({
  showOwnershipPercentage,
  onBack,
  submitting,
}: {
  showOwnershipPercentage: boolean;
  onBack?: () => void;
  submitting: boolean;
}) => {
  const formContext = useFormContext<DeclarationFormValues>();
  const accountType = formContext.values.accountType;

  const showFullName = isIndividualAccountType(accountType);

  return (
    <>
      <Flex flexDirection="column" gap={Sizes.MD}>
        {showFullName ? (
          <Flex justifyContent="space-between" gap={12}>
            <FormTextInput name="firstName" label="First name" isFullWidth />
            <FormTextInput name="middleName" label="Middle name" isFullWidth />
            <FormTextInput name="lastName" label="Last name" isFullWidth />
          </Flex>
        ) : (
          <FormTextInput
            label="Name"
            name="legalBusinessName"
            isFullWidth
            placeholder="This is usually the legal name of the management company/entity"
          />
        )}

        {showOwnershipPercentage && (
          <FormPercentInput label="Ownership percentage" name="ownershipPercentage" />
        )}
      </Flex>
      <Flex className={declarationButtonWrapper}>
        {onBack && <CancelButton onClick={onBack}>Back</CancelButton>}
        <SubmitButton isLoading={submitting}>Save</SubmitButton>
      </Flex>
    </>
  );
};
